import React from 'react';
import { Link } from 'react-router-dom';
import './BlogPost.css';

const WhatIsCslScreening: React.FC = () => {
  return (
    <article className="blog-post">
      <div className="blog-post-header">
        <Link to="/blog" className="blog-post-back">&larr; Back to Blog</Link>
        <h1>What Is CSL Screening and Why Does It Matter?</h1>
        <p className="blog-post-meta">Published March 6, 2026 &middot; 5 min read</p>
      </div>

      <div className="blog-post-content">
        <h2>Introduction</h2>
        <p>
          The Consolidated Screening List (CSL) is a collection of U.S. government lists that identify parties
          subject to export restrictions, sanctions, or other trade-related prohibitions. For any company involved
          in exporting goods, services, or technology, screening against these lists is not optional — it is a
          legal requirement.
        </p>

        <h2>What Lists Are Included in the CSL?</h2>
        <p>
          The CSL aggregates multiple lists from several U.S. agencies, including:
        </p>
        <ul>
          <li>Entity List (Bureau of Industry and Security)</li>
          <li>Specially Designated Nationals (SDN) List (OFAC)</li>
          <li>Denied Persons List (BIS)</li>
          <li>Unverified List (BIS)</li>
          <li>Military End User List (BIS)</li>
          <li>Nonproliferation Sanctions lists (State Department)</li>
        </ul>

        <h2>Why Does CSL Screening Matter?</h2>
        <p>
          Failing to screen business partners against the CSL can result in severe civil and criminal penalties,
          including fines up to $300,000 per violation and imprisonment. Beyond legal risk, violations can damage
          a company's reputation and its ability to do business internationally.
        </p>

        <h2>How Often Should You Screen?</h2>
        <p>
          Best practice calls for screening at multiple touchpoints: before onboarding a new customer, before
          shipping goods, and periodically for ongoing relationships. Regulations change frequently, and a
          party that was clear last month may appear on a list today.
        </p>

        <h2>Automating Your Screening Process</h2>
        <p>
          Manual screening is time-consuming and error-prone. Automated tools like CompanySieve cross-reference
          company names against the CSL and international sanctions lists, validate potential matches with AI,
          and generate audit-ready reports — all in seconds.
        </p>

        <div className="blog-post-cta">
          <p>Ready to automate your CSL screening?</p>
          <Link to="/register">Get Started with CompanySieve</Link>
        </div>
      </div>
    </article>
  );
};

export default WhatIsCslScreening;
